import React from 'react'

import { TableCell } from '@components/common/TableCell'
import { TableItemDate } from '@components/utils/TableItemDate'
import type { TableHeaders } from '@fourthwall/components'
import { InProgress, PriceString, ProfitString, TextBlockEllipsis } from '@fourthwall/components'

import type { State, ThankYou } from '../ThankYous.types'

export const getTableHeaders = (
  state: State,
  timezoneAbbreviation: string,
  { hideProfitColumn }: { hideProfitColumn: boolean },
): TableHeaders<ThankYou> => {
  const headers: TableHeaders<ThankYou> = [
    {
      id: state === 'SENT' ? 'updatedAt' : 'createdAt',
      label: `Date (${timezoneAbbreviation})`,
      render: ({ createdAt, updatedAt }) => (
        <div>
          <TableItemDate date={state === 'SENT' ? updatedAt : createdAt} />
        </div>
      ),
    },
    {
      id: 'supporter.fullName',
      label: 'Supporter',
      render: ({ supporter }) => (
        <TableCell mainContent={supporter.fullName || supporter.email} $ellipsis />
      ),
      width: 2,
    },
    {
      id: 'message',
      label: 'Message left',
      render: ({ message }) => (
        <TableCell
          mainContent={
            message ? <TextBlockEllipsis component="blockquote" text={message} /> : <>&ndash;</>
          }
        />
      ),
      width: 3,
    },
    {
      id: 'total.value',
      label: 'Order value',
      render: ({ total }) => <TableCell mainContent={<PriceString value={total.value} />} />,
    },
    {
      id: 'profit',
      label: 'Profit',
      hidden: hideProfitColumn,
      render: () => (
        <InProgress>
          <ProfitString value={32.32} />
        </InProgress>
      ),
    },
  ]

  return headers.filter((column) => !column.hidden)
}
